// interface

import { ProductName } from "types/general";
import { OnboardingState } from "types/onboarding";

export enum ApiNotificationErrorType {
  monitoringStatusUnavailable = "monitoring_status_unavailable",
  directDepositSwitchedAwayFromReset = "direct_deposit_switched_away_from_reset",
}

export enum ApiNotificationSource {
  pinwheel = "pinwheel",
  plaid = "plaid",
}

export enum ApiNotificationType {
  integrationError = "IntegrationErrorNotifier::Notification",
  dslUpdating = "DynamicSpendingLimits::UpdatingNotifier::Notification",
  dslUpdated = "DynamicSpendingLimits::UpdatedNotifier::Notification",
  optedToSkipPayrollLinking = "PayrollAccounts::PayrollLinkingSkippedNotifier::Notification",
  onboardingState = "Users::UserStateNotifier::Notification",
  incomeTaxReturnAccepted = "IncomeTaxReturns::AcceptedNotifier::Notification",
}

export interface ApiNotification {
  id: string;
  type: ApiNotificationType;
  actedAt: string | null;
  readAt: string | null;
  requireAction: boolean;
  params: {
    // TODO: Couple params to notification type
    errorType?: ApiNotificationErrorType;
    source?: ApiNotificationSource;
    product?: ProductName;
    state?: OnboardingState;
    jurisdiction?: string;
  };
}
